<template>
	<ModalFormCard :action="action" class="modal-default">
		<template #title>{{ showCreate ? 'Create contact' : 'Edit contact' }}</template>

		<template #default="{ saving, errors }">
            <Input
                v-model:value="value.first_name"
                groupClass="bg-grey text-15"
                label="First name"
                name="first_name"
                placeholder="Enter first name"
				:limit='30'
            />

            <Input
                v-model:value="value.last_name"
                groupClass="bg-grey text-15"
                label="Last name"
                name="last_name"
                placeholder="Enter last name"
				class='mt-4'
				:limit='30'
            />

			<Input
				v-model:value="value.email"
				class="mt-4"
				groupClass="!bg-grey text-15"
				label="Email address"
				name="email"
				placeholder="Email address"
				autocomplete="new-email"
				:limit='100'
			/>

			<Select :options='jobTitles' class='mt-4' label='Job title' name='job_title' v-model:value='value.job_title' valueKey='value'>
				<template #option='{ option }'>
					<div class='flex items-center gap-2'>
						<component :is='option.icon' :class='option.iconColor' class='w-4 h-4' />
						<p>{{ option.value }}</p>
					</div>
				</template>
			</Select>

			<Input
				v-model:value="value.contact_number_1"
				class="mt-4"
				groupClass="bg-grey text-15"
				label="Primary phone number"
                name="contact_number_1"
                placeholder="Phone number"
			/>

			<Input
				v-model:value="value.contact_number_2"
				v-if='numbersToShow >= 2'
				class="mt-4"
				groupClass="bg-grey text-15"
				label="Secondary phone number"
                name="contact_number_2"
                placeholder="Phone number"
			/>

			<Input
				v-model:value="value.contact_number_3"
				v-if='numbersToShow >= 3'
				class="mt-4"
				groupClass="bg-grey text-15"
				label="Secondary phone number"
                name="contact_number_3"
                placeholder="Phone number"
			/>

			<button class='icon-hover text-grey-900 flex items-center gap-2 text-15 mt-4'
				@click='numbersToShow++' type='button'
				v-if='numbersToShow <= 2'
			>
				<IconPlus class='w-4.5 h-4.5' />
				<p>Add an additional phone number</p>
			</button>

			<InputCheckbox class='mt-4' name='set_primary_contact' :value='value.set_primary_contact' @update:value='value.set_primary_contact = !value.set_primary_contact'>
				<p class='text-grey-900 text-14 pl-2'>Make this contact the primary contact</p>
			</InputCheckbox>

			<input type='hidden' :value='value.password' name='password' />
			<input type='hidden' :value='options.unit_id' name='unit_id' />

			<div class="modal-buttons pt-6">
				<ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					{{ showCreate ? 'Create contact' : 'Update contact' }}
				</ButtonSaving>
			</div>
		</template>
	</ModalFormCard>
</template>

<script>
import User from "~/models/user.js";
import Modal from "~/mixins/modal.js";
import InputFile from "~/components/customer/input/file.vue";

export default {
	mixins: [Modal],

	created() {
		this.setup(User, this.editingModel);

		if (this.editingModel != null) {
			this.numbersToShow += (this.editingModel.contact_number_2 && this.editingModel.contact_number_2.length > 0 ? 1 : 0) 
				+ (this.editingModel.contact_number_3 && this.editingModel.contact_number_3.length > 0 ? 1 : 0)
			
			this.action = '/admin/contact/' + this.editingModel.id;
		} else {
			this.value.password = this.$help.generatePassword()
		}
	},

	data() {
		return {
			action: '/admin/contact',
			canSeePassword: false,
			numbersToShow: 1,
			jobTitles: User.JobTitles()
		};
	},

	computed: {
		showCreate() {
			return this.editingModel == null
		},
	},

	components: {
		InputFile,
	},
};
</script>
